module.exports = __webpack_public_path__ + "img/featured-in-logos.833528c5.svg";